module.exports = __webpack_public_path__ + "img/speciality@2x.9ce1e184.png";